import styled from 'styled-components'

import PanelOld from 'components/Panel'
import Panel, { PanelTitle, PanelBody } from './Panel'

export default Object.assign(Panel, {
  Section: PanelBody,
  Title: styled(PanelTitle)``,
  Header: PanelTitle,
  Body: PanelBody,
  Footer: PanelOld.Footer,
})
